import { Meta, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { Maybe, ParkingSession } from 'types/generatedSchemaTypes';

type ANPRChargingInfoProps = {
  ongoingSession: Maybe<ParkingSession> | undefined;
};

const ANPRChargingInfo: React.FC<ANPRChargingInfoProps> = ({
  ongoingSession,
}) => {
  const { t } = useTranslation();
  const isANPR = ongoingSession?.type === 'ANPR';

  if (!isANPR) {
    return null;
  }

  return (
    <StyledWrapper mb={25}>
      <Meta
        color={theme.colors.gray300}
        testID="stop-charging-confirm-anpr-text">
        {t('parking.anprDescriptionNoWrap')}
      </Meta>
    </StyledWrapper>
  );
};

export default ANPRChargingInfo;
